// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__Yq5lU","iconWithCounter":"styles_iconWithCounter__l6fCM","counterForLabel":"styles_counterForLabel__jYOOL","counterForIcon":"styles_counterForIcon__p2f2W"};